// Admin configuration
// Obscure admin path for security - only share with authorized administrators
export const ADMIN_PATH = '/xkpz3595';

// Admin password is stored in AdminLogin component
